import React from 'react';
import PropTypes from 'prop-types'
import {BoxIconWrap, BoxIconInner, BoxIconTop, Icon, Heading, BoxIconBottom, Text, ListBoxIconWrap, ListBoxTitle} from './box-icon.style'
import List, {ListItem} from '../../ui/list';
import {
    FaLifeRing, FaCheck, FaPhone, FaEnvelope, FaPaperPlane, FaInfoCircle,
    FaBullseye, FaBusinessTime, FaMoneyCheckAlt, FaLayerGroup,
    FaAndroid, FaApple, FaBlender, FaChessBoard, FaCloud, FaDna, FaMedal, FaOilCan, FaDrum
} from 'react-icons/fa'

// Map font-awesome class names to react-icons components
const iconMap = {
    'fal fa-life-ring': FaLifeRing,
    'fa fa-check': FaCheck,
    'fal fa-check': FaCheck,
    'fal fa-phone': FaPhone,
    'fa fa-phone': FaPhone,
    'fal fa-envelope': FaEnvelope,
    'fa fa-envelope': FaEnvelope,
    'fal fa-paper-plane': FaPaperPlane,
    'fal fa-info-circle': FaInfoCircle,
    // Service page icons
    'fal fa-bullseye': FaBullseye,
    'fal fa-business-time': FaBusinessTime,
    'fal fa-money-check-alt': FaMoneyCheckAlt,
    'fal fa-layer-group': FaLayerGroup,
    'fab fa-android': FaAndroid,
    'fab fa-apple': FaApple,
    'fal fa-blender': FaBlender,
    'fal fa-chess-board': FaChessBoard,
    'fal fa-cloud': FaCloud,
    'fal fa-dna': FaDna,
    'fal fa-medal': FaMedal,
    'fal fa-oil-can': FaOilCan,
    'fas fa-drum-steelpan': FaDrum,
}

const BoxIcon = ({iconName, title, desc}) => {
    const IconComponent = iconMap[iconName]
    return(
        <BoxIconWrap>
            <BoxIconInner>
                <BoxIconTop>
                    {iconName && (
                        <Icon>
                            {IconComponent ? <IconComponent /> : null}
                        </Icon>
                    )}
                    {title && <Heading>{title}</Heading>}
                </BoxIconTop>
                {desc && (
                    <BoxIconBottom>
                        <Text>{desc}</Text>
                    </BoxIconBottom>
                )}
            </BoxIconInner>
        </BoxIconWrap>
    )
}

const ListBoxIcon = ({iconName, title, desc, list}) => {
    const IconComponent = iconMap[iconName]
    return(
        <BoxIconWrap>
            <BoxIconInner>
                <BoxIconTop>
                    {iconName && (
                        <Icon>
                            {IconComponent ? <IconComponent /> : null}
                        </Icon>
                    )}
                    {title && <Heading>{title}</Heading>}
                </BoxIconTop>
                {desc && (
                    <BoxIconBottom>
                        <Text>{desc}</Text>
                    </BoxIconBottom>
                )}
                { list && list.items && (
                    <ListBoxIconWrap>
                        <ListBoxTitle>
                            <Text>{list.title}</Text>
                        </ListBoxTitle>
                        <List layout={list.layout}>
                        {list.items.map(item => (
                            <ListItem>{item.text}</ListItem>
                        ))}
                        </List>
                    </ListBoxIconWrap>
                )}
            </BoxIconInner>
        </BoxIconWrap>
    )
}


BoxIcon.propTypes = {
    iconName: PropTypes.string,
    title: PropTypes.string,
    desc: PropTypes.string
}

BoxIcon.defaultProps = {
    iconName: "fal fa-life-ring",
    title: "Quality Assurance System",
    desc: "Our service offerings enhance customer experience throughout secure & highly functional end-to-end warranty management."
}

export {ListBoxIcon}

export default BoxIcon;